<template>
    <v-dialog v-model="getModalExcluirEtiqueta" max-width="500px" transition="dialog-transition">
        <v-card>
            <v-card-title>
                Excluir
            </v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja excluir?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalExcluirEtiqueta(false)" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="excluirEtiqueta(getEtiqueta)" outlined>Sim</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalExcluirEtiqueta',
                'getEtiqueta'
            ])
        },
        methods: {
            ...mapActions([
                'setModalExcluirEtiqueta',
                'excluirEtiqueta'
            ])
        }
    }
</script>